'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _d = require('d3');

exports.default = function (xScale, configuration, where) {
    var tickFormat = configuration.locale ? configuration.locale.timeFormat : configuration.tickFormat;

    //change where so the first letter will be uppercase
    where = '' + where[0].toUpperCase() + where.slice(1);

    var axis = undefined;
    if (where == 'Top') {
        axis = (0, _d.axisTop)().scale(xScale).tickFormat(tickFormat);
    } else {
        axis = (0, _d.axisBottom)().scale(xScale).tickFormat(tickFormat);
    }

    //const axis = d3[`axis${where}`]().scale(xScale).tickFormat(tickFormat);

    if (typeof configuration.axisFormat === 'function') {
        configuration.axisFormat(axis);
    }

    return axis;
};
//# sourceMappingURL=xAxis.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/xAxis.js
// module id = ../../../../ansyn-event-drops/dist-es5/xAxis.js
// module chunks = vendor